// ************************************
// Observer observes document for "updatePage" event, which is fired by individual
// modules like material slider and accessories slider
// on slide click of one of the above sliders, an ajax call is made and an event is triggered
// the event will trigger the Observer and changes the images of the observing modules

// in summary following changes:
// hero image, Onlineplaner Image, Fronten, OnlinePlaner BackgroundImage

class Observer {
    constructor (data) {
        this.$heroImage = document.querySelector('.heroimage__image picture');
        this.$front = document.querySelector('[data-material-slider-name="fronten"]');
        this.$summary = document.querySelectorAll('[data-summary]')[0];
    }

    init (data) {
        data.forEach(currentData => {
            // change hero image
            if (currentData.target === 'heroimage') {
                this.$heroImage.querySelector('source').srcset = currentData.image[0].mobile;
                this.$heroImage.querySelector('img').src = currentData.image[0].desktop;
            }
            // change front/corpus image
            if (currentData.target === 'front') {
                const $frontImage = this.$front.querySelector('.material-slider__background-figure.active picture');
                $frontImage.querySelector('source').srcset = currentData.image[0].mobile;
                $frontImage.querySelector('img').src = currentData.image[0].desktop;
            }
        });
    }
}

export { Observer };
